import { render, staticRenderFns } from "./TagAgents.vue?vue&type=template&id=f49af718&"
import script from "./TagAgents.vue?vue&type=script&setup=true&lang=js&"
export * from "./TagAgents.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f49af718')) {
      api.createRecord('f49af718', component.options)
    } else {
      api.reload('f49af718', component.options)
    }
    module.hot.accept("./TagAgents.vue?vue&type=template&id=f49af718&", function () {
      api.rerender('f49af718', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/widgets/conversation/TagAgents.vue"
export default component.exports